import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setChangeWidgetIconPosition: Function, // Function to set updated widget icon position
    setIsChangeWidgetIconCustomPosition: Function, // Function to set custom widget icon position flag
    setChangeWidgetIconCustomLeftPosition: Function, // function to set left position
    setChangeWidgetIconCustomRightPosition: Function, // function to set right position
    setChangeWidgetIconCustomTopPosition: Function, // function to set top position
    setChangeWidgetIconCustomBottomPosition: Function, // function to set bottom position
    setChangeWidgetIconHorizontalCenterPosition: Function, // function to set horizontal center position
    setChangeWidgetIconVerticalCenterPosition: Function, // function to set vertical center position
    setSubmitDisabled: Function
}


// component to render widget icon position
const WidgetIconPosition = (props: PropTypes) => {

    // Props
    const { setChangeWidgetIconPosition,
        setIsChangeWidgetIconCustomPosition,
        setChangeWidgetIconCustomLeftPosition,
        setChangeWidgetIconCustomRightPosition,
        setChangeWidgetIconCustomTopPosition,
        setChangeWidgetIconCustomBottomPosition,
        setChangeWidgetIconHorizontalCenterPosition,
        setChangeWidgetIconVerticalCenterPosition,
        setSubmitDisabled
    } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    // state
    const [widgetIconPosition, setWidgetIconPosition] = useState<string>('bottom_right');

    const [isWidgetIconCustomPosition, setIsWidgetIconCustomPosition] = useState<boolean>(false);

    const [isWidgetIconCustomTopBottomPosition, setIsWidgetIconCustomTopBottomPosition] = useState<number>(2);
    const [widgetIconCustomTopBottomPositionValue, setWidgetIconCustomTopBottomPositionValue] = useState<string>('');

    const [isWidgetIconCustomLeftRightPosition, setIsWidgetIconCustomLeftRightPosition] = useState<number>(2);
    const [widgetIconCustomLeftRightPositionValue, setWidgetIconCustomLeftRightPositionValue] = useState<string>('');


    useEffect(() => {
        if (isWidgetIconCustomPosition) {
            if (!widgetIconCustomTopBottomPositionValue || !widgetIconCustomLeftRightPositionValue) {
                setSubmitDisabled(true);
            }
            else {
                setSubmitDisabled(false);
            }
        }
        else{
            setSubmitDisabled(false);
        }
    }, [isWidgetIconCustomPosition, widgetIconCustomTopBottomPositionValue, widgetIconCustomLeftRightPositionValue])



    useEffect(() => {
        if (currentWebsite) {
            // check if current website position
            if (currentWebsite.widget_position) {
                setWidgetIconPosition(currentWebsite.widget_position);
            } else {
                setWidgetIconPosition('bottom_right');
            }

            // check if custom position is set
            if (currentWebsite.is_widget_custom_position === 1) {
                setIsWidgetIconCustomPosition(true);
            } else {
                setIsWidgetIconCustomPosition(false);
            }
            //console.log("currentWebsite.widget_position_vertical_center_offset", currentWebsite.widget_position_vertical_center_offset);
            // check if widget top position is set
            if (currentWebsite.widget_position_vertical_center_offset !== null) {
                //console.log("currentWebsite.widget_position_vertical_center_offset =>", currentWebsite.widget_position_vertical_center_offset);
                setIsWidgetIconCustomTopBottomPosition(3)
                setWidgetIconCustomTopBottomPositionValue(currentWebsite.widget_position_vertical_center_offset.toString());
            }
            else if (currentWebsite.widget_position_top !== null) {
                setWidgetIconCustomTopBottomPositionValue(currentWebsite.widget_position_top.toString());
                setIsWidgetIconCustomTopBottomPosition(1)
            } else if (currentWebsite.widget_position_bottom !== null) {
                setWidgetIconCustomTopBottomPositionValue(currentWebsite.widget_position_bottom.toString());
                setIsWidgetIconCustomTopBottomPosition(2)
            }

            // check if widget left position is set 
            if (currentWebsite.widget_position_horizontal_center_offset !== null) {
                setWidgetIconCustomLeftRightPositionValue(currentWebsite.widget_position_horizontal_center_offset.toString());
                setIsWidgetIconCustomLeftRightPosition(3)
            }
            else if (currentWebsite.widget_position_left !== null) {
                setWidgetIconCustomLeftRightPositionValue(currentWebsite.widget_position_left.toString());
                setIsWidgetIconCustomLeftRightPosition(1)
            } else if (currentWebsite.widget_position_right !== null) {
                setWidgetIconCustomLeftRightPositionValue(currentWebsite.widget_position_right.toString());
                setIsWidgetIconCustomLeftRightPosition(2)
            }

        }
    }, [currentWebsite]);



    // function to validate top bottom position
    const validateWidgetIconCustomTopBottomPosition = (TopBottomValue: string) => {

        const value = Number(TopBottomValue);

        let verticalMinValue: number;
        let verticalMaxValue: number;

        if (isWidgetIconCustomTopBottomPosition === 3) {
            verticalMinValue = -250;
            verticalMaxValue = 250;
        }
        else {
            verticalMinValue = 0;
            verticalMaxValue = 500;
        }

        const validate = () => {
            //console.log("validate called");
            if (TopBottomValue === "") {
                setWidgetIconCustomTopBottomPositionValue("0");
            }
            else if (!isNaN(value) && isFinite(value)) {
                // check if top/bottom value is more than 500
                if (parseInt(widgetIconCustomTopBottomPositionValue) > verticalMaxValue) {
                    setWidgetIconCustomTopBottomPositionValue(verticalMaxValue.toString());
                }
                // check if top/bottom value is less than 0
                else if (parseInt(widgetIconCustomTopBottomPositionValue) < verticalMinValue) {
                    setWidgetIconCustomTopBottomPositionValue(verticalMinValue.toString());
                }
                else {
                    setWidgetIconCustomTopBottomPositionValue(TopBottomValue);
                }
            }
            else {
                setWidgetIconCustomTopBottomPositionValue("0");
            }
        }

        //console.log("isWidgetIconCustomTopBottomPosition", isWidgetIconCustomTopBottomPosition);
        //console.log("TopBottomValue", TopBottomValue);

        if (isWidgetIconCustomTopBottomPosition === 3) {
            if (TopBottomValue !== "-") {
                validate();
            }
            else {
                setWidgetIconCustomTopBottomPositionValue("-");
            }

        }
        else {
            validate();
        }


    }

    // function to validate left right position
    const validateWidgetIconCustomLeftRightPosition = (LeftRightValue: string) => {

        console.log("validateWidgetIconCustomLeftRightPosition", LeftRightValue)

        const value = Number(LeftRightValue);

        let horizontalMinValue: number;
        let horizontalMaxValue: number;

        if (isWidgetIconCustomLeftRightPosition === 3) {
            horizontalMinValue = -250;
            horizontalMaxValue = 250;
        }
        else {
            horizontalMinValue = 0;
            horizontalMaxValue = 500;
        }

        const validate = () => {
            //console.log("validate called");
            //console.log("LeftRightValue", LeftRightValue === "", LeftRightValue === null);
            if (LeftRightValue === "" || LeftRightValue === null) {
                setWidgetIconCustomLeftRightPositionValue("0");
            }
            else if (!isNaN(value) && isFinite(value)) {
                // check if top/bottom value is more than 500
                if (parseInt(widgetIconCustomLeftRightPositionValue) > horizontalMaxValue) {
                    setWidgetIconCustomLeftRightPositionValue(horizontalMaxValue.toString());
                }
                // check if top/bottom value is less than 0
                else if (parseInt(widgetIconCustomLeftRightPositionValue) < horizontalMinValue) {
                    setWidgetIconCustomLeftRightPositionValue(horizontalMinValue.toString());
                }
                else {
                    setWidgetIconCustomLeftRightPositionValue(LeftRightValue);
                }
            }
            else {
                setWidgetIconCustomLeftRightPositionValue("0");
            }
        }

        if (isWidgetIconCustomLeftRightPosition === 3) {

            if (LeftRightValue !== "-") {
                validate();
            }
            else {
                setWidgetIconCustomLeftRightPositionValue("-");
            }

        }
        else {
            console.log("else");
            validate();
        }


    }



    useEffect(() => {
        // check if widget icon position is set
        if (widgetIconPosition) {
            setChangeWidgetIconPosition(widgetIconPosition);
        }
    }, [widgetIconPosition]);

    useEffect(() => {
        // check if widget icon custom position is set
        if (isWidgetIconCustomPosition) {
            setIsChangeWidgetIconCustomPosition(true);
        } else {
            setIsChangeWidgetIconCustomPosition(false);
        }
    }, [isWidgetIconCustomPosition]);

    useEffect(() => {
        // check if left/right position is set
        if (isWidgetIconCustomLeftRightPosition === 3) {
            setChangeWidgetIconHorizontalCenterPosition(widgetIconCustomLeftRightPositionValue);
            setChangeWidgetIconCustomRightPosition(null);
            setChangeWidgetIconCustomLeftPosition(null);
        }
        else if (isWidgetIconCustomLeftRightPosition === 1) {
            setChangeWidgetIconCustomLeftPosition(widgetIconCustomLeftRightPositionValue);
            setChangeWidgetIconCustomRightPosition(null);
            setChangeWidgetIconHorizontalCenterPosition(null);
        } else {
            setChangeWidgetIconCustomLeftPosition(null);
            setChangeWidgetIconHorizontalCenterPosition(null);
            setChangeWidgetIconCustomRightPosition(widgetIconCustomLeftRightPositionValue);
        }
    }, [isWidgetIconCustomLeftRightPosition, widgetIconCustomLeftRightPositionValue]);


    useEffect(() => {
        // check if top/bottom position is set
        if (isWidgetIconCustomTopBottomPosition === 3) {
            setChangeWidgetIconVerticalCenterPosition(widgetIconCustomTopBottomPositionValue);
            setChangeWidgetIconCustomBottomPosition(null);
            setChangeWidgetIconCustomTopPosition(null);
        }
        else if (isWidgetIconCustomTopBottomPosition === 1) {
            setChangeWidgetIconCustomTopPosition(widgetIconCustomTopBottomPositionValue);
            setChangeWidgetIconCustomBottomPosition(null);
            setChangeWidgetIconVerticalCenterPosition(null);
        }
        else {
            setChangeWidgetIconCustomTopPosition(null);
            setChangeWidgetIconVerticalCenterPosition(null);
            setChangeWidgetIconCustomBottomPosition(widgetIconCustomTopBottomPositionValue);
        }
    }, [isWidgetIconCustomTopBottomPosition, widgetIconCustomTopBottomPositionValue]);


    useEffect(()=>{
        if(isWidgetIconCustomTopBottomPosition && widgetIconCustomTopBottomPositionValue){
            validateWidgetIconCustomTopBottomPosition(widgetIconCustomTopBottomPositionValue);
        }
    },[isWidgetIconCustomTopBottomPosition, widgetIconCustomTopBottomPositionValue]);


    useEffect(()=>{
        if(isWidgetIconCustomLeftRightPosition && widgetIconCustomLeftRightPositionValue){
            validateWidgetIconCustomLeftRightPosition(widgetIconCustomLeftRightPositionValue)
        }
    },[isWidgetIconCustomLeftRightPosition, widgetIconCustomLeftRightPositionValue]);


    
    return (
        <>
            {isWidgetIconCustomPosition ? (
                <>
                    {console.log("widgetIconCustomTopBottomPositionValue", widgetIconCustomTopBottomPositionValue)}
                    <div className="aioa_dashboard-widget-custom-settings border-bottom">
                        <Form.Check
                            type="switch"
                            className="aioa_dashboard-switch"
                            id="custom-switch-position"
                            label={`${t('Enable precise accessibility widget icon position')}`}
                            checked={isWidgetIconCustomPosition}
                            onChange={(e) => setIsWidgetIconCustomPosition(!isWidgetIconCustomPosition)}
                        />
                    </div>
                    <div className="aioa_dashboard-widget-settings-controls">
                        <div className="mb-4 pb-4 border-bottom">
                            <Row>
                                <Col>
                                    <div className={`aioa-dashboard-widget-settings-custom-size-control`}>
                                        <div className="d-flex">
                                            <Form.Control
                                                size="lg"
                                                aria-label={t(`icon position from ${widgetIconCustomTopBottomPositionValue}`).toString()}
                                                aria-describedby="top_bottom_description"
                                                className="border"
                                                type="text"
                                                value={widgetIconCustomTopBottomPositionValue !== null ? widgetIconCustomTopBottomPositionValue : 0}
                                                onChange={(e) => validateWidgetIconCustomTopBottomPosition(e.target.value)}
                                                onBlur={(e) => validateWidgetIconCustomTopBottomPosition(e.target.value)}
                                                isValid={(parseInt(widgetIconCustomTopBottomPositionValue) >= (isWidgetIconCustomTopBottomPosition === 3 ? -250 : 0) && parseInt(widgetIconCustomTopBottomPositionValue) <= (isWidgetIconCustomTopBottomPosition === 3 ? 250 : 500)) ? true : false}
                                                isInvalid={(parseInt(widgetIconCustomTopBottomPositionValue) < (isWidgetIconCustomTopBottomPosition === 3 ? -250 : 0) || parseInt(widgetIconCustomTopBottomPositionValue) > (isWidgetIconCustomTopBottomPosition === 3 ? 250 : 500)) ? true : false}
                                                required
                                            />
                                            <div className="input-group-text">px</div>
                                        </div>
                                        <div className="text-muted" id="top_bottom_description">
                                            {isWidgetIconCustomTopBottomPosition === 3 ? t('center position offset info') : t('position input info text')}
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <Form.Select
                                        size="lg"
                                        aria-label={t("Icon vertical position").toString()}
                                        value={isWidgetIconCustomTopBottomPosition}
                                        onChange={(e) => setIsWidgetIconCustomTopBottomPosition(Number(e.target.value))}>
                                        <option value={1}>{t('To the top')}</option>
                                        <option value={2}>{t('To the bottom')}</option>
                                        <option value={3}>{t('To the vertical center')}</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col>
                                <div className={`aioa-dashboard-widget-settings-custom-size-control`}>
                                    <div className="d-flex">
                                        <Form.Control
                                            size="lg"
                                            aria-label={t(`icon position from ${widgetIconCustomLeftRightPositionValue}`).toString()}
                                            aria-describedby="left_right_description"
                                            className="border"
                                            type="text"
                                            value={widgetIconCustomLeftRightPositionValue !== null ? widgetIconCustomLeftRightPositionValue : 0}
                                            onChange={(e) => validateWidgetIconCustomLeftRightPosition(e.target.value)}
                                            onBlur={(e) => validateWidgetIconCustomLeftRightPosition(e.target.value)}
                                            isValid={((parseInt(widgetIconCustomLeftRightPositionValue)) >= (isWidgetIconCustomLeftRightPosition === 3 ? -250 : 0) && parseInt(widgetIconCustomLeftRightPositionValue) <= (isWidgetIconCustomLeftRightPosition === 3 ? 250 : 500)) ? true : false}
                                            isInvalid={(parseInt(widgetIconCustomLeftRightPositionValue) < (isWidgetIconCustomLeftRightPosition === 3 ? -250 : 0) || parseInt(widgetIconCustomLeftRightPositionValue) > (isWidgetIconCustomLeftRightPosition === 3 ? 250 : 500)) ? true : false}
                                            required
                                        />
                                        <div className="input-group-text">px</div>
                                    </div>
                                    <div className="text-muted" id="left_right_description">
                                        {isWidgetIconCustomLeftRightPosition === 3 ? t('center position offset info') : t('position input info text')}
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <Form.Select
                                    size="lg"
                                    aria-label={t("Icon horizontal position").toString()}
                                    value={isWidgetIconCustomLeftRightPosition}
                                    onChange={(e) => setIsWidgetIconCustomLeftRightPosition(Number(e.target.value))}>
                                    <option value={1}>{t('To the left')}</option>
                                    <option value={2}>{t('To the right')}</option>
                                    <option value={3}>{t('To the horizontal center')}</option>
                                </Form.Select>
                            </Col>
                        </Row>
                    </div>
                </>
            ) : (
                <>
                    <div className="aioa_dashboard-widget-settings-btns">
                        <Button onClick={() => setWidgetIconPosition("top_left")} className={`${widgetIconPosition === `top_left` ? 'active' : ''}`} size="lg">{t(`Top Left`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("top_center")} className={`${widgetIconPosition === `top_center` ? 'active' : ''}`} size="lg">{t(`Top Center`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("top_right")} className={`${widgetIconPosition === `top_right` ? 'active' : ''}`} size="lg">{t(`Top Right`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("middle_left")} className={`${widgetIconPosition === `middle_left` ? 'active' : ''}`} size="lg">{t(`Middle Left`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("middle_right")} className={`${widgetIconPosition === `middle_right` ? 'active' : ''}`} size="lg">{t(`Middle Right`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("bottom_left")} className={`${widgetIconPosition === `bottom_left` ? 'active' : ''}`} size="lg">{t(`Bottom Left`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("bottom_center")} className={`${widgetIconPosition === `bottom_center` ? 'active' : ''}`} size="lg">{t(`Bottom Center`)}</Button>
                        <Button onClick={() => setWidgetIconPosition("bottom_right")} className={`${widgetIconPosition === `bottom_right` ? 'active' : ''}`} size="lg">{t(`Bottom Right`)}</Button>
                    </div>

                    <div className="aioa_dashboard-widget-custom-settings border-top">
                        <Form.Check
                            type="switch"
                            className="aioa_dashboard-switch"
                            id="custom-switch-position"
                            label={`${t('Enable precise accessibility widget icon position')}`}
                            checked={isWidgetIconCustomPosition}
                            onChange={(e) => setIsWidgetIconCustomPosition(!isWidgetIconCustomPosition)}
                        />
                    </div>
                </>
            )}
        </>
    )
}

export default WidgetIconPosition;